<template>
  <div class="contract-cycle">
    <div v-if="isPcFlag" class="contract-cycle-pc">
      <div class="total-title">穿透合同生命周期的智能化管理方案</div>
      <div class="content">
        <div class="content-item" v-for="(item, index) in dataList" :key="index">
          <div class="img-text">
            <img class="img" :src="item.img" alt="" />
            <div class="text">{{ item.text }}</div>
          </div>
          <img v-if="item.key !== 8" class="arrow" src="../../../assets/images/smart-contract/arrow.png" alt="" />
        </div>
      </div>
    </div>
    <div class="contract-cycle-h5"></div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    dataList: Array,
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.contract-cycle {
  width: 100%;
  .contract-cycle-pc {
    width: 100%;
    .columnDisplay(center, center);
    .total-title {
      width: 100%;
      height: 72px;
      font-size: 34px;
      background: #de2221;
      color: #fff;
      .basisDisplay(center, center);
    }
    .content {
      width: 100%;
      max-width: 1320px;
      .basisDisplay(center, center);
      padding: 59px 0 69px 0;
      .content-item {
        .basisDisplay(center, center);
        margin-right: 5px;
        .img-text {
          box-shadow: 3px 4px 13px 0px rgba(154, 164, 176, 0.19);
          border-radius: 9px;
          margin-right: 5px;
          .img {
            width: 137px;
            height: 111px;
          }
          .text {
            width: 100%;
            height: 60px;
            font-size: 18px;
            color: #0f0f0f;
            .basisDisplay(center, center);
            white-space: pre-wrap;
            text-align: center;
          }
        }
        .arrow {
          width: 20px;
          height: 17px;
        }
      }
    }
  }
}
</style>
